import React from 'react';
import { Modal, Spin } from 'antd';

// production
const Url = " https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://da.ddycj.com/pay?student_id="
// staging
// const Url = " https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://dastaging.ddycj.com/pay?student_id="


export default class PayModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      loading: true
    }

  }

  componentWillReceiveProps(newProps) {
  }

  handleImageLoaded() {
    this.setState({
      loading: false
    })
  }

  onCancel() {
    this.props.callbackPayModal();
  }

  render() {
    return (
      <Modal
        className="pay-modal"
        footer={null}
        title={null}
        onCancel={this.onCancel.bind(this)}
        visible={this.props.visible}
        maskClosable={false}
      >
        <p className="pay-label">打开<span style={{fontSize: '18px'}}> 微信 </span>扫描以下二维码，进行解锁</p>
        <p className="pay-label">支付完成后请刷新页面</p>
        <Spin spinning={this.state.loading}>
          <img src={Url + (this.props.studentId)} className="pay-img" onLoad={this.handleImageLoaded.bind(this)}/>
        </Spin>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/share/PayModal.jsx